"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validateInputLocale = (inputLocale) => {
    var _a, _b, _c, _d;
    try {
        const region = new Intl.DateTimeFormat(inputLocale);
        if (region.resolvedOptions().locale) {
            return region.resolvedOptions().locale;
        }
        else {
            try {
                inputLocale = (_b = (_a = Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat()) === null || _a === void 0 ? void 0 : _a.resolvedOptions()) === null || _b === void 0 ? void 0 : _b.locale;
                if (inputLocale) {
                    return inputLocale;
                }
                else {
                    return 'en-US';
                }
            }
            catch (err) {
                return 'en-US';
            }
        }
    }
    catch (err) {
        try {
            inputLocale = (_d = (_c = Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat()) === null || _c === void 0 ? void 0 : _c.resolvedOptions()) === null || _d === void 0 ? void 0 : _d.locale;
            if (inputLocale) {
                return inputLocale;
            }
            else {
                return 'en-US';
            }
        }
        catch (err) {
            return 'en-US';
        }
    }
};
exports.default = validateInputLocale;
